import { t } from "i18next";
import React from "react";
import { Row, Form, Col } from "react-bootstrap";
import $ from "jquery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import DatePicker, { registerLocale } from "react-datepicker";
import pl from "date-fns/locale/pl";
registerLocale("pl", pl);

const EditPassForm = (props) => {
    const { setUserPass, userPass, setFormChanged, blockForm } = props;

    return (
        <Row>
            <Col xs={6} lg={2} md={3}>
                <Form.Group className="mb-3" controlId={`passEntries`}>
                    <Form.Label className="w-100">
                        {t(`passes.passEntries`)} <span className="req">*</span>
                    </Form.Label>
                    <Form.Control
                        type="number"
                        value={userPass.up_entries}
                        onChange={(el) => {
                            setUserPass({ ...userPass, up_entries: el.target.value });
                            $("#passEntries").removeClass("is-invalid");
                            setFormChanged(true);
                        }}
                        placeholder={t(`typeNumber`)}
                        disabled={blockForm}
                        min={userPass.cnt_signed}
                    />
                </Form.Group>
            </Col>
            <Col xs={6} lg={2} md={3}>
                <Form.Group className="mb-3" controlId={`passPrice`}>
                    <Form.Label className="w-100">
                        {t(`passes.passPrice`)} <span className="req">*</span>
                    </Form.Label>
                    <Form.Control
                        type="number"
                        value={userPass.up_price}
                        onChange={(el) => {
                            setUserPass({ ...userPass, up_price: el.target.value });
                            $("#passPrice").removeClass("is-invalid");
                            setFormChanged(true);
                        }}
                        placeholder={t(`typeNumber`)}
                        disabled={blockForm}
                    />
                </Form.Group>
            </Col>
            <Col xs={9} lg={4} md={5}>
                <Form.Group className="mb-3" controlId={`passDuration`}>
                    <Form.Label className="w-100">
                        {t(`passes.passDurationFromBuyDate`)} <span className="req">*</span>
                    </Form.Label>
                    <Form.Control
                        type="number"
                        value={userPass.up_duration_days}
                        onChange={(el) => {
                            setUserPass({ ...userPass, up_duration_days: el.target.value });
                            $("#passDuration").removeClass("is-invalid");
                            setFormChanged(true);
                        }}
                        placeholder={t(`typeNumber`)}
                        disabled={blockForm}
                    />
                </Form.Group>
            </Col>
            <Col xs={9} lg={3} xl={3}>
                <Form.Group>
                    <Form.Label>
                        {t("activationTill")} <span className="req">*</span>
                    </Form.Label>
                    <DatePicker
                        autoComplete="off"
                        selected={userPass.up_due_date}
                        onChange={(date) => {
                            setUserPass({ ...userPass, up_due_date: date });
                            $("#userPassDueDate").removeClass("is-invalid");
                            setFormChanged(true);
                        }}
                        showIcon
                        locale="pl"
                        dateFormat="yyyy-MM-dd"
                        icon={<FontAwesomeIcon icon={faCalendar} />}
                        className="mb-3"
                        placeholderText={t("choose")}
                        id="userPassDueDate"
                        disabled={blockForm}
                    />
                </Form.Group>
            </Col>
        </Row>
    );
};

export default EditPassForm;
